import { render } from "./create-productors-file.vue?vue&type=template&id=3dd97954&ts=true"
import script from "./create-productors-file.vue?vue&type=script&lang=ts"
export * from "./create-productors-file.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__